<template>
  <div class="white">
    <h1><span style="font-weight: 400;">&ldquo;Verbotene W&ouml;rter&rdquo; - wie spielt man das?</span></h1>
<p><span style="font-weight: 400;">&ldquo;Verbotene W&ouml;rter&rdquo; ist ein Gesellschaftsspiel f&uuml;r mindestens zwei Teams.</span></p>
<ol>
<li style="font-weight: 400;"><span style="font-weight: 400;">Alle Spieler sollten in Teams aufgeteilt werden (Minimum 2, Maximum 4)</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Jedes Team muss sich einen Namen geben.</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Geben Sie nach dem Start der Anwendung die Teams ein und bestimmen Sie die Parameter des Spiels. F&uuml;r Anf&auml;nger wird die Grundeinstellung empfohlen.</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Das Spiel ist in Runden unterteilt, in denen alle Teams W&ouml;rter pr&auml;sentieren.</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">In jeder Runde w&auml;hlt jedes Team eine Person aus seinem Team aus, den "PRESENTER", der das WORT pr&auml;sentiert. Ein Spieler aus einem anderen Team, genannt "ARBITER", unterst&uuml;tzt die Anwendung und pr&uuml;ft, ob der pr&auml;sentierende Spieler das VERBOTENE WORT nicht verwendet hat.</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Die Aufgabe von ARBITER ist es, Punkte zu vergeben, wenn das Team des PRESENTERs das Wort err&auml;t oder die Worte auf Wunsch des PRESENTERs wegl&auml;sst. Au&szlig;erdem kann der ARBITER das Team PRESENTER bestrafen, falls der PRESENTER das verbotene Wort verwendet oder die Regeln verletzt.</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Jedes der Teams hat 90 Sekunden Zeit, um die meisten Punkte f&uuml;r das Erraten der gr&ouml;&szlig;tm&ouml;glichen Anzahl von W&ouml;rtern zu erhalten, die vom PRESENTER pr&auml;sentiert werden.</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Der PRESENTER kann w&auml;hrend seiner Runde:</span></li>
<ol>
<li style="font-weight: 400;"><span style="font-weight: 400;">gestikulieren</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">das WORT beschreiben, ohne das gesuchte WORT oder die verbotenen W&ouml;rter zu verwenden, einschlie&szlig;lich:</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">der fremdsprachigen Entsprechung</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Varianten des Wortes</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">Verbindungen</span></li>
<li style="font-weight: 400;"><span style="font-weight: 400;">einzelne Buchstaben des Alphabets oder anderer Codes</span></li>
</ol>
<li style="font-weight: 400;"><span style="font-weight: 400;">Das Spiel wird so lange gespielt, bis die festgelegte Anzahl von Punkten erreicht ist (Standardeinstellung: 20 Punkte).</span></li>
</ol>
<p><span style="font-weight: 400;">Viel Spa&szlig;!</span></p>
    <div class="button">
      <router-link to="/" class="back">
        <button>Zurück</button>
      </router-link>
    </div>
    <br>
    <footer>
      <a href="https://grupa.itdesk.eu">2018 &copy; Progressive Web Applications coded by itDesk.eu</a>
    </footer>
  </div>
</template>


<script>
export default {};
</script>


<style>
.white {
  color: #fff;
}
.back {
  display: grid;
  justify-content: center;
}
.button > li {
  list-style: none;
}
footer {
  color: white;
  font-size: 1.8vh;
  position: absolute;
  bottom: 0;
  width: 99vw;
  height: 3vh;
  text-align: center;
}
footer > a {
  color: #fff;
  text-decoration: none;
}
</style>
